import {
    ADD_UPDATE_ACCOUNT_TYPE_ADMIN_SUCCESS,
    ADD_UPDATE_ACCOUNT_TYPE_ADMIN_FAILED,
    LOADING_ADD_UPDATE_ACCOUNT_TYPE_ADMIN,
    NETWORK_ERROR_ADD_UPDATE_ACCOUNT_TYPE_ADMIN,
    RESET_ADD_UPDATE_ACCOUNT_TYPE_ADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAddUpdateAccountTypeAdmin = () => {
    return { type: RESET_ADD_UPDATE_ACCOUNT_TYPE_ADMIN };
};

const addUpdateAccountTypeAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADD_UPDATE_ACCOUNT_TYPE_ADMIN });
    await adminServices
        .post("addupdateaccounttypeadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADD_UPDATE_ACCOUNT_TYPE_ADMIN_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADD_UPDATE_ACCOUNT_TYPE_ADMIN_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADD_UPDATE_ACCOUNT_TYPE_ADMIN, payload: err });
        });
};

export { resetAddUpdateAccountTypeAdmin, addUpdateAccountTypeAdmin };
